import React from 'react'
const Spinner = () => {
    return (
        <>
            <div className="spinner-border text-warning mt-5" role="status">
                <span className="visually-hidden">Loading...</span>
            </div>
        </>
    )
}

export default Spinner
